import script from "./TheAppUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAppUpdate.vue?vue&type=script&setup=true&lang=js"

import "./TheAppUpdate.vue?vue&type=style&index=0&id=481cce2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481cce2a"]])

export default __exports__